import { jsx as i } from "react/jsx-runtime";
import { c as m } from "./index-Cu0xwYjD.js";
import * as n from "react";
const _ = "_card_1u7u9_1", e = "_shadow_1u7u9_11", f = "_cardLoading_1u7u9_15", a = {
  card: _,
  shadow: e,
  cardLoading: f
}, u = n.forwardRef(
  ({ className: d, children: r, shadow: o, isLoading: s, ...c }, t) => /* @__PURE__ */ i(
    "div",
    {
      ref: t,
      ...c,
      className: m(
        d,
        a.card,
        o && a.shadow,
        s && a.cardLoading
      ),
      children: r
    }
  )
);
u.displayName = "Card";
export {
  u as C,
  a as c
};
